/*
 * File: d:\projects\AutoFiFront\src\Content\Home\HomeAboutUs\HomeAboutUs.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday March 8th 2023 11:28:22 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import style from 'Content/Home/HomeAboutUs/HomeAboutUs.module.css';
import ButtonAlt from 'Theme/Component/ButtonAlt';
import AboutUsStyled from 'Theme/Component/AboutUsStyled';
import { useNavigate } from 'react-router-dom';
import translator from 'MultiLanguage/TranslationWrapper';
import RouterPathResolver from 'Config/Router/RouterPathResolver';

type AboutUsProps = {
    text: string,
    imgLeft?: boolean,
    imgDisplay?: boolean,
    btnDisplay?: boolean,
    color?: string,
    bgColor?: string,
    column?: boolean,
    translate?: boolean
};

function AboutUs (props: AboutUsProps) {
    const navigate = useNavigate();
    const goto = ()=>{
        const url = RouterPathResolver.routeAbout.path;
        navigate(url);
    };

    return(
        <AboutUsStyled imgLeft={props.imgLeft} bgColor={props.bgColor} color={props.color} column={props.column}>
            <article className={`${props.imgDisplay ? style.textaboutUs : style.textaboutUsSolo}`}>
                {
                    props.translate ?
                        <p>{translator.decode(`${props.text}`)} </p>
                        :
                        <p>{props.text} </p>
                }
                {
                    props.btnDisplay ? <ButtonAlt onClick={goto} maxWidth={"50%"}>{translator.decode("aboutUs.knowMore")}</ButtonAlt> : null
                }
            </article>
                {
                    props.imgDisplay ? <img className={`${style.image}`} src="/carBack.png" alt="image d'une voiture"/> : null
                }
        </AboutUsStyled>
    );
}

export default AboutUs;
